import { useCredentialVaultEditing } from "./use-credential-vault-editing";
import type { CredentialsResult } from "../types";

/** Provider profile and onboarding retain their existing entrypoint and uploader mode. */
export function useProviderCredentialEditing({
  userId,
  ...options
}: {
  userId: string;
  data: CredentialsResult | null;
  enabled?: boolean;
  uploadButtonClassName?: string;
  uploadPresentation?: "toggle" | "dropzone";
}) {
  return useCredentialVaultEditing({
    ...options,
    scope: { kind: "provider", userId },
  });
}

export type ProviderCredentialEditing = ReturnType<
  typeof useProviderCredentialEditing
>;
